import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import CONFIG from "../../../config.json";
export const GET_LIST_MILESTONE = 'GET_LIST_MILESTONE'
export const ADD_ITEM_MILESTONE = 'ADD_ITEM_MILESTONE'
export const DELETE_ITEM_MILESTONE = 'DELETE_ITEM_MILESTONE'
export const UPDATE_ITEM_MILESTONE = 'UPDATE_ITEM_MILESTONE'
export const getData = () => (dispatch) => {
    axios.get(CONFIG.SERVER_URL+'milestones').then((res) => {
        dispatch({
            type: GET_LIST_MILESTONE,
            payload: JSON.parse(res.data.data),
        })
    })

}

export const addData = (data) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    console.log('getData', data)
    
    if(data.file){
        formData.append(
            "file",
            data.file,
            data.file.name,
        );
    }
    formData.append(
        "headline",
        data.headline
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "description",
        data.description
    );
    formData.append(
        "year",
        data.year
    );
    formData.append(
        "ordering",
        data.ordering
    );
    
    axios.post(CONFIG.SERVER_URL+'milestones/add', formData).then((res) => {
        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        dispatch({
            type: ADD_ITEM_MILESTONE,
            payload: res.data.data,
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}

export const deleteData = (id) => (dispatch) => {
    
    axios.post(CONFIG.SERVER_URL+'milestones/delete/'+id).then((res) => {

        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: DELETE_ITEM_MILESTONE,
            payload: res.data,
            id
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}
export const updateData = (data, id) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    if(data.file){
        formData.append(
            "file",
            data.file,
            data.file.name,
        );
    }
    formData.append(
        "headline",
        data.headline
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "description",
        data.description
    );
    formData.append(
        "year",
        data.year
    );
    formData.append(
        "ordering",
        data.ordering
    );
    axios.post(CONFIG.SERVER_URL+'milestones/update/'+id, formData).then((res) => {
        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: UPDATE_ITEM_MILESTONE,
            payload: res.data.data,
            id
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}
